import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { SettingsGroup } from './settings-group.interface';
import { SettingsGroupService } from './settings-group.service';

const service = new SettingsGroupService();

export interface SettingsGroupState {
   settingsGroups: Array<SettingsGroup>;
}

const SettingsGroupStore: Module<SettingsGroupState, StoreState> = {
   namespaced: true,
   state: { settingsGroups: [] },
   getters: { settingsGroups: (state) => state.settingsGroups },
   mutations: {
      SET_SETTINGS_GROUPS(state, settingsGroups: Array<SettingsGroup>) {
         state.settingsGroups = settingsGroups;
      },
   },
   actions: {
      async getSettingsGroups(context, query?: LocationQuery) {
         const response = await service.getSettingsGroups({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_SETTINGS_GROUPS', response.data);
         return response;
      },

      async getSettingsGroup(context, { id, query }: { id: number; query?: LocationQuery }) {
         const response = await service.getSettingsGroup(id, query);
         return response;
      },
   },
};

export default SettingsGroupStore;
